import { Injectable } from '@angular/core';
import { WebService } from '../web/web.service';
import { CfgStampa, TipoQuestionario } from './config-stampe.service';

@Injectable({
  providedIn: 'root',
})
export class ConfigStampeWebService {
  constructor(private webService: WebService) {}

  public getLineeGuida(contesto: TipoQuestionario) {
    return this.webService.doGet('/api/v1/linee-guida-stampe/' + contesto, {});
  }

  public salvaLineaGuida(cfg: CfgStampa, contesto: TipoQuestionario) {
    return this.webService.doPut('/api/v1/linee-guida-stampe/' + contesto, cfg);
  }

  public salvaTempalteMail(
    mailNotifica: string,
    mailInvio: string,
    landingPage: string,
    contesto: TipoQuestionario,
  ) {
    return this.webService.doPut('/api/v1/linee-guida-stampe/testi-mail/' + contesto, {
      mailInvio,
      mailNotifica,
      landingPage,
    });
  }
  public getSignedLinkFile(fileName: string) {
    return this.webService.doGet('/api/v1/gcp-storage/get-signed-url', { fileName });
  }
}
